import ClientDetails from "./screens/ClientsScreen/ClientDetailsScreen/ClientDetails";
import ClientPersonalDetails from "./screens/ClientsScreen/ClientDetailsScreen/ClientPersonalDetails";
import CreateCandidateScreen from "./screens/CreateCandidateScreen";
import Communication from "./components/Clients/ClientDetails/WhatElse/Communication/Communication";
import ReferenceManagement from "./components/Clients/ClientDetails/WhatElse/ReferenceManagement/ReferenceManagement";
import Observation from "./components/Clients/ClientDetails/WhatElse/Observation/Observation";
import VisitAnalysis from "./components/Clients/ClientDetails/WhatElse/VisitAnalysis/VisitAnalysis";
import AuditStats from "./components/Clients/ClientDetails/WhatElse/AuditStats/AuditStats";
import VaccinationRecord from "./components/Clients/ClientDetails/WhatElse/VaccinationRecord/VaccinationRecord";
import ConditionsAndAlerts from "./components/Clients/ClientDetails/ConditionsAndAlerts/ConditionsAndAlerts";
import BodyMap from "./components/Clients/ClientDetails/BodyMap/BodyMap";
import Assessments from "./components/Clients/ClientDetails/Assessments/Assessments";
import CommunicationNote from "./components/Clients/ClientDetails/Assessments/CommunicationNote/CommunicationNote";
import CarePlanHistory from "./components/Clients/ClientDetails/Assessments/CarePlanHistory/CarePlanHistory";
import Medications from "./components/Clients/ClientDetails/Medications/Medications";
import CandidatesScreen from "./screens/CandiatesScreen/CandidatesScreen";
import ReferenceDataManagement from "./components/settings/ReferenceDataManagement";
import ClientAllergies from "./components/settings/client/ClientAllergies";
import Scheduling from "./components/scheduling/Scheduling";
import CreateLocation from "./components/settings/location/Locations";
import CarePathway from "./components/settings/carePathway/CarePathway";
import Template from "./components/scheduling/Template";
import VisitChecklist from "./components/settings/client/VisitChecklist";
import CreateClientScreen from "./screens/ClientsScreen/CreateClientScreen";
import VisitPlanScreen from "./screens/VisitPlanScreen";
import VisitTimelineScreen from "./screens/VisitTimelineScreen";
import OperationDashboardScreen from "./screens/OperationDashboardScreen";
import AuditLogsScreen from "./screens/AuditLogsScreen";
import WeeklyPlanner from "./components/scheduling/WeeklyPlanner";
import MedicineList from "./components/settings/medicine/MedicineList";
import GenerateReportScreen from "./screens/GenerateReportScreen/GenerateReportScreen";
import HouseKeepingScreen from "./screens/HouseKeepingScreen";
import { TextMessage, Message } from "./screens/Message";
import EnvironmentalRiskAssessment from "./components/Clients/ClientDetails/Assessments/EnvironmentalRiskAssessment.js/EnvironmentalRiskAssessment";
import EnvRiskQuestion from "./components/settings/client/EnvRiskQuestion";
import BodyMapScreen from "./components/Clients/ClientDetails/BodyMap/BodyMapScreen";
import WeeklyScheduleLogs from "./components/settings/logs/WeeklyScheduleLogs";
import ClientAssessment from "./components/Clients/ClientDetails/Assessments/ClientAssessments/ClientAssessments";
import DynamicCarePlanForm from "./components/Clients/ClientDetails/Assessments/ActiveCareTabs/DynamicCarePlanForm";
import ClientAssignedAssessments from "./components/Clients/ClientDetails/Assessments/ClientAssessments/AssignedClientAssessments";
import RiskTypeManagement from "./components/settings/RiskTypes";
import MentalCapacity from "./screens/ReferenceData/MentalCapacity";
import { IssueTypes, Vaccinations } from "./screens/ReferenceData";
import IncidentReport from "./screens/Reports";
import TemporaryInspector from "./screens/CandiatesScreen/TemporaryInspector";
import ReviewedCarePlans from "./screens/ClientsScreen/Assessment/ReviewedCarePlans";
import EmailCommunication from "./screens/Message/Email";
import { ECMCompliance, VoiceOfCustomer } from "./screens/KPI";
import EasyReports from "./screens/GenerateReportScreen/EasyReports";
import FunderManagement from "./screens/FunderManagement/FunderManagement";
import { BankHolidayManager, FinancePage } from "./screens/Finance";
import InitialAssessmentList from "./screens/ClientsScreen/Assessment/InitialAssessment";
import AssessmentSchemaView from "./screens/ClientsScreen/Assessment/AssessmentSchemaView";
import { ClientsScreen } from "./screens/ClientsScreen";
import SettingsScreen from "./screens/SettingsScreen/SettingsScreen";
import AboutFormBuilder from "./components/settings/aboutFormBuilder/AboutFormBuilder";
import ResendLink from "./screens/SetPassword/ResendLink";
import SetPassword from "./screens/SetPassword/SetPassword";
import DocumentsScreen from "./screens/DocumentsScreen";

const routes = [
  { path: "/", element: <OperationDashboardScreen /> },
  { path: "/scheduling", element: <Scheduling /> },
  { path: "/kpi", element: <ECMCompliance /> },
  { path: "/voc", element: <VoiceOfCustomer /> },
  { path: "/template", element: <Template /> },
  { path: "/candidates", element: <CandidatesScreen /> },
  { path: "/set-password", element: <SetPassword /> },
  { path: "/resend-link", element: <ResendLink /> },
  { path: "/candidate/create", element: <CreateCandidateScreen /> },
  { path: "/employee/temporary-inspector", element: <TemporaryInspector /> },
  { path: "/clients/", element: <ClientsScreen /> },
  { path: "/finance/", element: <FinancePage /> },
  { path: "/billing/bank-holiday/", element: <BankHolidayManager /> },
  { path: "/audit-logs/", element: <AuditLogsScreen /> },
  { path: "/team-chat/", element: <Message /> },
  { path: "/text-message/", element: <TextMessage /> },
  { path: "/email/", element: <EmailCommunication /> },
  { path: "/create-client", element: <CreateClientScreen /> },
  { path: "/client/:id/", element: <ClientDetails /> },
  { path: "/personal-details/:id/", element: <ClientPersonalDetails /> },
  { path: "/:clientID/communication", element: <Communication /> },
  { path: "/weekly-planner", element: <WeeklyPlanner /> },
  { path: "/observation/:id/", element: <Observation /> },
  { path: "/medication/:id/", element: <Medications /> },
  { path: "/care-plan-history/:id/", element: <CarePlanHistory /> },
  { path: "/reviewed-careplans/:ClientID/", element: <ReviewedCarePlans /> },
  { path: "/body-map/:id/", element: <BodyMapScreen /> },
  {
    path: "/environmental-risk-assessment/:id/",
    element: <EnvironmentalRiskAssessment />,
  },
  {
    path: "/assessment/:id/",
    element: <ClientAssessment />,
  },
  { path: "/active-assessments/:clientID/", element: <ClientAssignedAssessments />},
  { path: "/active-assessment/:id/", element: <ClientAssessment />,},
  { path: "/:clientID/careplan/:carePlanID/:assignedCarePlanID/", element: <DynamicCarePlanForm /> },
  { path: "/reference-management", element: <ReferenceManagement /> },
  { path: "/audit-stats", element: <AuditStats /> },
  { path: "/reports", element: <GenerateReportScreen /> },
  { path: "/report-managemnt", element: <EasyReports /> },
  { path: "/settings/funder-management", element: <FunderManagement /> },
  { path: "/house-keeping", element: <HouseKeepingScreen /> },
  { path: "/incident-report", element: <IncidentReport /> },
  { path: "/vaccination-record", element: <VaccinationRecord /> },
  { path: "/visit-analysis/:id/", element: <VisitAnalysis /> },
  { path: "/conditions-and-alerts/:ClientID/", element: <ConditionsAndAlerts /> },
  { path: "/body-map", element: <BodyMap /> },
  { path: "/:id/assessments", 
    element: <Assessments />,
  },
  { path: "/:clientID/assessments/initial-assessment", element: <InitialAssessmentList />},
  { path: ":clientID/assessments/initial-assessment/:typeId/view", element: <AssessmentSchemaView />},
  { path: "/communication-note", element: <CommunicationNote /> },
  { path: "/medications", element: <Medications /> },
  { path: "/visit-plan", element: <VisitPlanScreen /> },
  { path: "/visit-timeline", element: <VisitTimelineScreen /> },
  { path: "/operation-dashboard", element: <OperationDashboardScreen /> },
  { path: "/settings/location", element: <CreateLocation /> },
  { path: "/settings/care-pathway", element: <CarePathway /> },
  { path: "/settings/about/forms", element: <AboutFormBuilder /> },
  { path: "/system-settings", element: <SettingsScreen /> },
  { path: "/uploads", element: <DocumentsScreen />},
  {
    path: "settings/reference-data",
    element: <ReferenceDataManagement />,
    children: [
      {
        path: "client-allergies",
        element: <ClientAllergies />,
      },
      {
        path: "visit-checklist",
        element: <VisitChecklist />,
      },
      {
        path: "medicine",
        element: <MedicineList />,
      },
      {
        path: "risk-types",
        element: <RiskTypeManagement />,
      },
      {
        path: "mental-capacity",
        element: <MentalCapacity />,
      },
      {
        path: "body-map",
        element: <IssueTypes />,
      },
      {
        path: "vaccinations",
        element: <Vaccinations/>,
      },
      {
        path: "schedule-logs",
        element: <WeeklyScheduleLogs />,
      },
    ],
  },
];

export default routes;
